// Style
import { ReactComponent as ReactLogo } from "../../assets/images/logo.svg";
import { ReactComponent as ReactRoundedTop } from "../../assets/images/splash/bg-top.svg";
import { ReactComponent as ReactRoundedBottom } from "../../assets/images/splash/bottom.svg";

import "../../@core/scss/components/splash.scss";

function Splash(props) {
  const {children} = props;
  return (
    <div className="splash__screen">
      <ReactRoundedTop className="top-rounded"/>
      <div className="container">
        <div className="d-flex">
          <ReactLogo className="img-fluid logo" />
          {children}
        </div>
      </div>
      <ReactRoundedBottom className="img-bootom"/>
    </div>
  );
}

export default Splash;
